export const API_FORMAT_DATE = 'YYYY-MM-DD'
export const SALES_SOLIC_STOCK_IN_SALES = 1
export const PROVIDER_SOLIC_STOCK_IN_SALES = 2

export const SALES_SOLIC_STOCK_IN_PURCHASES = 2
export const PROVIDER_SOLIC_STOCK_IN_PURCHASES = 1

export const SOLIC_ATTRIBUTES_CODE = 1
